import { Button } from '@material-tailwind/react';
import { getCookie } from '../../../utils/helper';
import { HomeIcon, PlusIcon } from '@heroicons/react/24/solid';
import images from '../../../assets/images';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function Quydinh() {
  const auth = getCookie('token');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const fetchIp = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      if (response.status === 200) {
        setLoading(false);
        if (auth['wifi'] !== data.ip && (Number(auth?.permission) === 2 || Number(auth?.permission) === 4)) {
          navigate('/dashboard', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } else {
        setLoading(false);
        navigate('/dashboard', { replace: true });
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div>
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70">
          <div className="relative w-32 h-32">
            {/* Viền xoay */}
            <div className="absolute inset-0 rounded-full border-4 border-yellow-500 border-t-transparent animate-spin"></div>

            {/* Logo ở giữa */}
            <div className="absolute inset-4 rounded-full bg-yellow-100/70 shadow-[0_0_20px_5px_rgba(250,204,21,0.6)] flex items-center justify-center ">
              <img
                src={images.logoklandload} // Thay đường dẫn logo tại đây
                alt="Logo"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      )}
      <div className="flex bg-black text-white font-bold justify-between p-2">
        <div className="flex gap-5">
          {/* <div className="text-3xl font-bold cursor-pointer text-amber-800 mr-10">
            <img src={images.logoklandpng} alt="1 " width={'50px'} />
          </div> */}
          {/* <Link to="/"> */}
          <div className="flex gap-1 items-center cursor-pointer hover:text-orange-300" onClick={fetchIp}>
            <HomeIcon className="h-5 w-5" />
            KHO KEYLAND
          </div>
          {/* </Link> */}
          <Link to="/addbds">
            <div className="flex gap-1 items-center cursor-pointer hover:text-orange-300">
              <PlusIcon className="h-5 w-5" /> Tạo mới
            </div>
          </Link>
        </div>
        <div className="text-orange-300"> xin chào, {auth?.name ? auth?.name : auth?.usernames}</div>
      </div>

      <div className="m-auto lg:p-10 h-screen bg-[#efefef]">
        <div className="lg:flex gap-4 ml-4 items-center">
          <img src={images.logoklandpng} alt="1 " width={'280px'} />
          <span className="text-xl lg:text-3xl font-bold">Quản Lý Tài Khoản Cá Nhân</span>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4 border p-4 bg-white">
          <div>
            <p className="font-bold mb-2">QUY TẮC CHỐNG GIẤU THÔNG TIN TẠI KEYLAND</p>
            <p className="mb-2">
              – Các thành viên KEYLAND khi có thông tin sản phẩm nên nhập ngay lên hệ thống để tránh thất thoát thông
              tin hoặc mắc lỗi không đáng có.{' '}
            </p>
            <p className="mb-2">
              – Một hợp đồng được ký môi giới bởi thành viên KEYLAND mà chưa có thông tin trên hệ thống thì phần tiền
              nguồn sẽ được chia đều cho toàn công ty.
            </p>
            <p className="mb-2">
              – Sản phẩm sau khi nhập lên hệ thống chưa đủ 2 tiếng mà được chốt thì 50% phần tiền nguồn sẽ được chia đều
              cho toàn công ty.
            </p>
          </div>
          <div>
            <p className="font-bold mb-2">QUY TẮC MINH BẠCH THÔNG TIN TẠI KEYLAND</p>
            <p className="mb-2">
              – Mọi thay đổi về người sỡ hữu nguồn (người nhập, người nhập thay, nhập thay cho ai, hay sỡ hữu chung với
              ai…) chỉ được thay đổi trong vòng 3 ngày kể từ ngày nhập. Mọi thay đổi sau ba ngày đều không được dùng làm
              căn cứ.
            </p>
            <p className="mb-2">
              – Sản phẩm chung nhiều người phải ghi chú mã nhân viên của những người đồng thuận chung nguồn. Nếu có
              tranh chấp xảy ra công ty giải quyết dựa trên sự thỏa thuận của các bên nhưng nếu không đi đến được sự
              đồng thuận sẽ căn cứ trên thông tin hợp lệ tại kho hàng.
            </p>
            <p className="mb-2">
              – Số tờ/số thửa cần nhập chính xác theo sổ (bỏ qua phần số tờ/thửa gốc hoặc trong dấu ngoặc kép).
            </p>
            <p className="mb-2">Ví dụ: tờ số 2 (gốc 1) thửa số 3 (II-a-1b) thì nhập như sau: </p>
            <p className="mb-2">Mục số tờ nhập “2” | Mục số thửa nhập “3”</p>
            <p className="mb-2">
              – Với sản phẩm có nhiều thửa thì YÊU CẦU BẮT BUỘC nhập đầy đủ từng thửa bằng cách nhấn nút “Thêm tờ/thửa”
              để bổ sung thông tin thửa đất.
            </p>
            <p className="mb-2">– Nếu BĐS Chưa có Sổ {'>'} chọn Pháp lý: Không có sổ</p>
            <p className="mb-2">
              {' '}
              + Ô số Tờ, hãy nhập phường thay cho số tờ (ví dụ sản phẩm ở phường 1 nhập “1”, ở Xuân Thọ nhập “XT”)
            </p>
            <p className="mb-2">
              {' '}
              + Ô số Thửa, hãy nhập tổng diện tích phần nguyên thay cho số thửa (Ví dụ 101,5m2 nhập “101”)
            </p>
            <p className="mb-2">
              – KEYLAND chỉ căn cứ trao hoa hồng nguồn theo hệ thống: https://staff.keyland123.com. Mọi tranh chấp cá
              nhân các bên phải tự giải quyết dựa trên tinh thần hợp tác và nền tảng văn hoá của công ty.
            </p>
          </div>
          <div>
            <p className="font-bold mb-2">QUY TẮC CHIA SẺ THÔNG TIN TẠI KEYLAND</p>
            <p className="mb-2">
              – Nhằm bảo vệ tài sản chung của công ty, số điện thoại chủ bất động sản không được chia sẻ ra ngoài công
              ty, không được đưa lên các hội nhóm hoặc đăng bài trên các nền tảng mạng xã hội như Zalo, Viper,
              Instagaram, Telegaram, Tiktok, Youtube, Facebook…v.v, và không được xem là nguồn hợp lệ của bất kỳ ai
              thông qua các nền tảng đó.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
